<template>
  <el-card>
    <div v-show="!showFilter">
      <el-row class="cadastro-title pb-2">
        <el-col :span="20"><span>Respostas {{title}}</span></el-col>
        <el-col :span="4">
          <filter-button :showfilter.sync="showFilter"></filter-button>
        </el-col>
      </el-row>
      <hr/>
      <el-row>
        <el-col v-loading="isLoading">
          <el-alert  v-show="!perguntas.length"
            title="Faça um filtro"
            type="warning"
            show-icon>
          </el-alert>
          <table class="tabela" v-show="perguntas.length">
            <thead class="tabela-head-linha">
            <tr class="tabela-body-linha">

              <th colspan="2">
                <el-input v-model="queryFilter" size="small" placeholder="Buscar..."
                          style="padding-right: 1em"></el-input>
              </th>
              <th v-for="competencia in competencias">{{competencia.label}}</th>
            </tr>
            </thead>
            <tbody>
            <tr @click="changePerguntaSelected(pergunta)" class="tabela-body-linha clickable"
                v-for="pergunta in listFilter">
              <td class="tabela-celula w-5" style="color: #212121; font-weight: bold">{{pergunta.id}}</td>
              <td class="tabela-celula w-25">
                <strong class="tabela-centrocusto-nome" itemprop="name">{{pergunta.label}}</strong>
              </td>
              <td v-for="competencia in competencias">
                {{ getValue(competencia.id ,pergunta.respostas) }}
              </td>
            </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>
    </div>
    <resposta-filter class="pt-2"
                     :showfilter.sync="showFilter"
                     v-show="showFilter || !perguntas.length"
                     @filtroAplicado="filter"></resposta-filter>
    <grafico-line-dialogo :visible.sync="showGraph"
                          :title="this.selectedGraph.label"
                          :categorias="this.selectedGraph.categorias"
                          :axioy="{title:'Valores'}"
                          :series="[{ name:'Resposta' ,data :  this.selectedGraph.dados} ]"></grafico-line-dialogo>
  </el-card>
</template>

<script>
  import {mapState} from 'vuex'
  import numeral from 'numeral'
  import locales from 'numeral/locales';
  import RespostaFilter from "./RespostaFilter";
  import FilterButton from "@/components/shared/FilterButton";
  import GraficoLineDialogo from "../Shared/GraficoLineDialogo";

  export default {
    name: "Index",
    components: {GraficoLineDialogo, FilterButton, RespostaFilter},
    data() {
      return {
        queryFilter: '',
        selectedGraph: {},
        showGraph: false,
        showFilter: false,
        isLoading: false,
        title: '',
        competencias: [],
        perguntas: []
      }
    },
    computed: {
      ...mapState(['centroCustoList', 'indicadorList', 'anoSelected', 'mesSelected', 'centroCustoSelected']),
      listFilter() {
        return this.perguntas.filter(item => {
          return item.label.toUpperCase().indexOf(this.queryFilter.toUpperCase()) > -1
        })
      }
    },
    methods: {
      changePerguntaSelected(pergunta) {
        const repostas = collect(pergunta.respostas)

        this.showGraph = true
        this.selectedGraph = {
          label: pergunta.label,
          categorias: collect(this.competencias).sortBy('id').pluck('label').all(),
          dados: repostas.sortBy('competencia_id').pluck('valor').all()
        }
      },
      getValue(competenciaId, listaRespostas) {
        const resposta = listaRespostas.find(item => item.competencia_id === competenciaId)
        return resposta ? this.formataNumero(resposta.valor) : ''
      },
      async filter(event) {
        try {
          this.isLoading = true
          let url = `${process.env.API_PATH}/resposta/ano/${event.ano}/centrocusto/${event.centroCusto}`
          let {data} = await axios.get(url)
          this.perguntas = [...data.perguntas]
          this.competencias = [...data.competencias]
        } catch (error) {
          trataErrors(error)
        } finally {
          this.isLoading = false
        }
      },
      formataNumero(valor) {
        return numeral(Number(valor)).format('0.00')
      }
    },
    async mounted() {
    }
  }
</script>

<style scoped>
  tr:nth-child(even) {
    background-color: #f2f2f2
  }

  .legenda span {
    padding: .5em;
    margin: .3em;
  }

  .tabela {
    font-size: .7em;
    width: 100%;
  }

  .tabela-head-linha {
    border-bottom: solid 1px #ddd;
    height: 3em;
    font-size: 1.5em;
  }

  .tabela-body-linha {
    border-bottom: solid 1px #ddd;
    height: 3em;
  }

  .tabela-centrocusto-nome {
    font-weight: bold;
    color: #2E2E2E;
  }

  .tabela-total-value {
    font-weight: bold;
    text-align: right;
    color: #2E2E2E;
  }
</style>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Resposta/index.vue